(function () {
  'use strict';

  var VIEWPORT_ANCHOR = 0.4;
  var DESKTOP_MQ = window.matchMedia('(min-width: 750px)');

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function NineDescSection(root) {
    this.root = root;
    this.allSlides = Array.prototype.slice.call(root.querySelectorAll('[data-nine-desc-slide]'));
    this.activeIndex = -1;
    this.scrollTicking = false;
    this.onScroll = this.onScroll.bind(this);
    this.onViewportChange = this.onViewportChange.bind(this);

    this.desktopSteps = parseInt(root.getAttribute('data-desktop-steps'), 10) || 0;
    this.mobileSteps = parseInt(root.getAttribute('data-mobile-steps'), 10) || 0;

    if (this.desktopSteps === 0 && this.mobileSteps === 0) return;

    this.bindDots();
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onViewportChange, { passive: true });

    if (typeof DESKTOP_MQ.addEventListener === 'function') {
      DESKTOP_MQ.addEventListener('change', this.onViewportChange);
    } else if (typeof DESKTOP_MQ.addListener === 'function') {
      DESKTOP_MQ.addListener(this.onViewportChange);
    }

    this.onViewportChange();
  }

  NineDescSection.prototype.isDesktop = function () {
    return DESKTOP_MQ.matches;
  };

  NineDescSection.prototype.viewportKey = function () {
    return this.isDesktop() ? 'desktop' : 'mobile';
  };

  NineDescSection.prototype.visibilityAttr = function () {
    return this.isDesktop() ? 'data-visible-desktop' : 'data-visible-mobile';
  };

  NineDescSection.prototype.indexAttr = function () {
    return this.isDesktop() ? 'data-slide-index-desktop' : 'data-slide-index-mobile';
  };

  NineDescSection.prototype.stepCount = function () {
    return this.isDesktop() ? this.desktopSteps : this.mobileSteps;
  };

  NineDescSection.prototype.getSlides = function () {
    var attr = this.visibilityAttr();
    return this.allSlides.filter(function (slide) {
      return slide.getAttribute(attr) === 'true';
    });
  };

  NineDescSection.prototype.getSentinels = function () {
    var track = this.root.querySelector('[data-nine-desc-track="' + this.viewportKey() + '"]');
    if (!track) return [];
    return Array.prototype.slice.call(track.querySelectorAll('[data-nine-desc-sentinel]'));
  };

  NineDescSection.prototype.getDots = function () {
    return Array.prototype.slice.call(
      this.root.querySelectorAll('[data-nine-desc-dot][data-viewport="' + this.viewportKey() + '"]')
    );
  };

  NineDescSection.prototype.onViewportChange = function () {
    this.setActive(0, true);
    if (this.stepCount() >= 2) {
      this.onScroll();
    }
  };

  NineDescSection.prototype.bindDots = function () {
    var self = this;
    Array.prototype.slice
      .call(this.root.querySelectorAll('[data-nine-desc-dot]'))
      .forEach(function (dot) {
        dot.addEventListener('click', function () {
          if (dot.getAttribute('data-viewport') !== self.viewportKey()) return;
          var index = parseInt(dot.getAttribute('data-slide-index'), 10);
          if (Number.isNaN(index)) return;
          self.scrollToIndex(index);
        });
      });
  };

  NineDescSection.prototype.onScroll = function () {
    if (this.stepCount() < 2) return;
    if (this.scrollTicking) return;
    this.scrollTicking = true;
    var self = this;
    window.requestAnimationFrame(function () {
      self.scrollTicking = false;
      self.updateActive();
    });
  };

  NineDescSection.prototype.updateActive = function () {
    var sentinels = this.getSentinels();
    if (!sentinels.length) return;

    var pin = this.root.querySelector('.nine-desc__pin');
    if (!pin) return;

    var pinRect = pin.getBoundingClientRect();
    if (pinRect.bottom <= 0 || pinRect.top >= window.innerHeight) return;

    var anchor = window.innerHeight * VIEWPORT_ANCHOR;
    var bestIndex = 0;
    var bestDistance = Infinity;

    sentinels.forEach(function (sentinel, index) {
      var rect = sentinel.getBoundingClientRect();
      var center = rect.top + rect.height * 0.5;
      var distance = Math.abs(center - anchor);
      if (distance < bestDistance) {
        bestDistance = distance;
        bestIndex = index;
      }
    });

    this.setActive(bestIndex);
  };

  NineDescSection.prototype.scrollToIndex = function (index) {
    var sentinel = this.getSentinels()[index];
    if (!sentinel) {
      this.setActive(index, true);
      return;
    }

    var rect = sentinel.getBoundingClientRect();
    var center = rect.top + rect.height * 0.5;
    var target = window.scrollY + center - window.innerHeight * VIEWPORT_ANCHOR;

    window.scrollTo({
      top: Math.max(0, target),
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
    });
  };

  NineDescSection.prototype.setActive = function (index, force) {
    var slides = this.getSlides();
    var dots = this.getDots();

    if (!slides.length) return;
    if (index < 0 || index >= slides.length) return;
    if (!force && index === this.activeIndex) return;

    this.activeIndex = index;

    this.allSlides.forEach(function (slide) {
      slide.classList.remove('is-active', 'is-active-desktop', 'is-active-mobile');
    });

    slides.forEach(function (slide, slideIndex) {
      var isActive = slideIndex === index;
      slide.classList.toggle('is-active', isActive);
      if (isActive) {
        slide.removeAttribute('hidden');
      } else {
        slide.setAttribute('hidden', '');
      }
    });

    dots.forEach(function (dot, dotIndex) {
      var isActive = dotIndex === index;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  };

  function init() {
    document.querySelectorAll('[data-nine-desc-scroll]').forEach(function (root) {
      if (root.nineDescBound) return;
      root.nineDescBound = true;
      new NineDescSection(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
